import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/icon/search.png'
import _imports_1 from '@/assets/image/icon/cancel.png'


const _withScopeId = n => (_pushScopeId("data-v-757aed66"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "search" }
const _hoisted_3 = { class: "search__select" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "search__line" }, null, -1))

import { ref, watch, computed } from 'vue'
import { useRouter } from 'vue-router'
import { Field, Button } from 'vant'


export default /*#__PURE__*/_defineComponent({
  __name: 'MSearch',
  props: {
  modelValue: { type: String, default: '' },
  placeholder: String,
  maxlength: { type: String, default: '200' },
  isLink: Boolean,
  isCancel: { type: Boolean, default: true },
},
  emits: ['update:modelValue', 'handleCancel', 'handleChange'],
  setup(__props, { emit: emits }) {

const props = __props;




const router = useRouter()
const placeholder = ref(props.placeholder || '请输入搜索内容...')

const searchValue = computed({
  get: () => props.modelValue,
  set: (newValue) => emits('update:modelValue', newValue),
})
const handleCancel = () => {
  searchValue.value = ''
  emits('handleCancel')
}
const handleSearch = () => {
  // emits('update:modelValue', searchValue.value)
  console.log('searchValue.value==>', searchValue.value)
  emits('handleChange', searchValue.value)
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "left-content", {}, () => [
          _createElementVNode("img", {
            src: _imports_0,
            onClick: handleSearch
          })
        ])
      ]),
      _hoisted_4,
      (__props.isLink)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: "/search-goods"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Field), {
                modelValue: _unref(searchValue),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(searchValue) ? (searchValue).value = $event : null)),
                placeholder: placeholder.value
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_unref(Field), {
            key: 1,
            modelValue: _unref(searchValue),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(searchValue) ? (searchValue).value = $event : null)),
            placeholder: placeholder.value,
            maxlength: props.maxlength
          }, null, 8, ["modelValue", "placeholder", "maxlength"])),
      (props.isCancel)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            (_unref(searchValue))
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "search__cancel",
                  src: _imports_1,
                  onClick: handleCancel
                }))
              : _createCommentVNode("", true),
            _createVNode(_unref(Button), { onClick: handleSearch }, {
              default: _withCtx(() => [
                _createTextVNode("搜索")
              ]),
              _: 1
            })
          ], 64))
        : (_openBlock(), _createBlock(_unref(Button), {
            key: 3,
            onClick: handleSearch
          }, {
            default: _withCtx(() => [
              _createTextVNode("搜索")
            ]),
            _: 1
          }))
    ])
  ]))
}
}

})